<ng-template #alertDialog let-c="close" let-d="dismiss">
  <div class="modal-header" *ngIf="showHeader">
    <div class="float-right" *ngIf="showHeader">
      <button type="button" class="btn btn-link text-dark" (click)="c('cancelled')"><i class="fas fa-times"></i></button>
    </div>
    <div [innerHTML]="headerContent | safeHtml"></div>
  </div>
  <div class="modal-body" *ngIf="showBody">
    <div class="float-right" *ngIf="!showHeader">
      <button type="button" class="btn btn-link text-dark" (click)="c('cancelled')"><i class="fas fa-times"></i></button>
    </div>
    <div [innerHTML]="bodyContent | safeHtml"></div>
  </div>
  <div class="modal-footer" *ngIf="showFooter" [innerHTML]="footerContent | safeHtml"></div>
</ng-template>
